module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-sso",
    class: _vm.$style.root
  }, [(_vm.loading) ? _c('loading') : [_c('gotu-nav-button', {
    attrs: {
      "theme": "default-cta",
      "className": "btn-login btn-success"
    },
    on: {
      "click": _vm.getLoginUrl
    }
  }, [_vm._v(_vm._s(_vm._f("uppercase")(_vm.$t('pos.login.sso'))))])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-748c64a7"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/login/sso/Sso.vue
// module id = 2062
// module chunks = 1